var baseDatepickerOpts = {
    locale: 'ja',
    dayViewHeaderFormat: 'YYYY年 M月',
    format: 'YYYY/MM/DD HH:mm',
    icons: {
        time: 'far fa-clock',
        date: 'far fa-calendar-alt',
        up: 'fas fa-arrow-up',
        down: 'fas fa-arrow-down',
    },
    buttons: {
        showClose: true,
    },
};

$(() => {
    if (document.getElementById('admin-support-form') != null) {
        $('.datetimepicker').datetimepicker(baseDatepickerOpts);
        $('.datetimepicker').blur(function() {
            $('#' + this.id).datetimepicker('hide');
        });

        $(document).on("click", '.js-add-support-content', function(e) {
            e.preventDefault();
            let template_image = $('.js-support-image').last();
            let template_content = $('.js-support-content').last();
            let _image = template_image.clone(true);
            let _content = template_content.clone(true);
            $($(_image).find('input, textarea')).removeClass('is-invalid');
            $($(_content).find('input, textarea')).removeClass('is-invalid');

            _image.find('input').val('');
            _image.find('.js-support-exist-image').remove();
            _content.find('textarea').val('');
            template_content.after(_content);
            template_content.after(_image);

            // name 番号振り直し
            $('.js-support-image').each(function (idx) {
                let name = 'image_path[' + idx +']';
                $(this).find('input[type=file]').attr('name', name);
            });

            $('.js-support-content').each(function (idx) {
                let name = 'content[' + idx +']';
                $(this).find('textarea').attr('name', name);
            });
        });

        $(document).on('click', '.js-delete-content-image', function(e) {
            if (window.confirm('本当に削除しますか？')) {
                location.href = $(this).data('href');
            }
        });

        $(document).on('click', '.js-delete-content', function(e) {
            if (window.confirm('本当に削除しますか？')) {
                location.href = $(this).data('href');
            }
        });
    }
});
